import React from 'react';
import {func, shape, string, bool} from 'prop-types';
import Snackbar, {SnackbarOrigin} from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import './Notification.scss';

function Notification({notification, closeNotification}:any) {
    const anchorOrigin: SnackbarOrigin = {
        vertical: 'top',
        horizontal: 'center',
    };
    const hideDuration = 5000;
    
    return (
        <Snackbar
            anchorOrigin={anchorOrigin}
            open={notification.isVisible}
            onClose={closeNotification}
            autoHideDuration={notification.manualHide ? null : hideDuration}
        >
            <MuiAlert
                className="notification"
                onClose={closeNotification}
                severity={notification?.type}
                elevation={6}
                variant="filled"
            >
                {notification.text}
            </MuiAlert>
        </Snackbar>
    );
}

Notification.propTypes = {
    closeNotification: func.isRequired,
    notification: shape({
        type: string,
        text: string,
        isVisible: bool,
    }).isRequired,
};

export default Notification;
